'use strict';function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');let

SocketResponse=function(){
function SocketResponse(status){let body=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};_classCallCheck(this,SocketResponse);
this.status=status;
this.body=_.exists(body.toJSON)?body.toJSON():body;
}SocketResponse.

succeeded=function succeeded(response){
return response.status==='Ok';
};SocketResponse.

FromError=function FromError(thrownError){
if(thrownError.name==='StatusCodeError'){
return new SocketResponse('HttpError',{
httpStatus:thrownError.statusCode,
errors:_.has(thrownError,'error.errors')?thrownError.error.errors:void 0});

}

if(thrownError.name==='RequestError'){
return new SocketResponse('ConnectionError',{
code:_.has(thrownError,'error.code')?thrownError.error.code:void 0});

}

throw thrownError;
};SocketResponse.

attemptWithResponse=function(){var ref=_asyncToGenerator(function*(asyncMethod,asyncErrorHandler){let asyncOnSuccess=arguments.length>2&&arguments[2]!==void 0?arguments[2]:function(){var ref=_asyncToGenerator(function*(result){return SocketResponse.Ok(result)});return function(result){return ref.apply(this,arguments)}}();
return yield SocketResponse.attempt(asyncMethod,asyncErrorHandler,asyncOnSuccess);
});function attemptWithResponse(asyncMethod,asyncErrorHandler){let asyncOnSuccess=arguments.length>2&&arguments[2]!==void 0?arguments[2]:function*(result){return SocketResponse.Ok(result)};return ref.apply(this,arguments)}return attemptWithResponse}();SocketResponse.

attempt=function(){var ref=_asyncToGenerator(function*(
asyncMethod)

{let asyncErrorHandler=arguments.length>1&&arguments[1]!==void 0?arguments[1]:function(){var ref=_asyncToGenerator(function*(error){return SocketResponse.FromError(error)});return function(error){return ref.apply(this,arguments)}}();let asyncOnSuccess=arguments.length>2&&arguments[2]!==void 0?arguments[2]:function(){var ref=_asyncToGenerator(function*(result){return SocketResponse.Ok()});return function(result){return ref.apply(this,arguments)}}();

let result;
try{
result=yield asyncMethod();
}catch(error){
return yield asyncErrorHandler(error);
}

return yield asyncOnSuccess(result);
});function attempt(asyncMethod){let asyncErrorHandler=arguments.length>1&&arguments[1]!==void 0?arguments[1]:function*(error){return SocketResponse.FromError(error)};let asyncOnSuccess=arguments.length>2&&arguments[2]!==void 0?arguments[2]:function*(result){return SocketResponse.Ok()};return ref.apply(this,arguments)}return attempt}();SocketResponse.

isHttpError=function isHttpError(response,status){
_.ensureInstanceOf('object',response);
_.ensureInstanceOf('number',status);
return response.status==='HttpError'&&response.body.httpStatus===status;
};SocketResponse.

safeDeserializeDate=function safeDeserializeDate(date,tag){
return date instanceof Date||date===void 0||date===null?
date:
new Date(date);
};return SocketResponse}();


module.exports=SocketResponse;
module.exports.Ok=function(body){return new SocketResponse('Ok',body)};
module.exports.Error=function(status){return new SocketResponse(status)};
//# sourceMappingURL=socketResponse.js.map
